import { Typography } from "@mui/material";
import { BuilderDefaultComponentProps } from "./BuilderH1";
import React from "react";

export default function BuilderH2(props: BuilderDefaultComponentProps) {
  return (
    <Typography
      component="h2"
      sx={{
        all: "unset",
      }}
    >
      {props.text}
    </Typography>
  );
}
